import { useCallback, useState, useLayoutEffect, useMemo } from "react";
import { Row, Col } from "react-bootstrap"
import FilterReport from "./header/FilterReport"
import styles from "./style.module.css"
import { Tag } from "rsuite"
import { format,startOfMonth, startOfWeek } from "date-fns"
import axiosService from "../../utils/axios.service";
import _ from "lodash"
import async from "async"
import { Line } from '@ant-design/plots';
import { Spin } from "antd"
import getDates from "../constant/getDates"
import { DataGrid } from '@mui/x-data-grid';
import "./scss/report.scss"
import StorageService from "../../utils/storage.service";
import { Tooltip, Button } from "antd";

import { Cosmetics } from "../../enums/cosmetics.enum"

const configChart = (data, convertCurrency) => {
    const config = {
        data: data,
        padding: 'auto',
        xField: 'date',
        yField: 'value',
        height: 520,
        yAxis: {
            label: {
                formatter: (v) => `${v}`.replace(/\d{1,3}(?=(\d{3})+$)/g, (s) => `${s},`),
            },
        },
        tooltip: {
            formatter: (data) => {
                return {
                    name: data.date,
                    value: convertCurrency(data.value)
                };
            },
        },
        slider: {
            start: 0,
            end: 1,
        },

        xAxis: {
            label: {
                autoRotate: true,
                style: {
                    fontSize: 10
                },
            },
        },
        minColumnWidth: 20,
        maxColumnWidth: 20,
        point: {
            size: 5,
            shape: 'circle',
            style: {
                fill: 'blue',
                stroke: '#5B8FF9',
                lineWidth: 2,
            },
        },

    };
    return config
}

const ReportDaily = () => {
    const columns = [
        { 
            field: 'date', 
            headerName: 'Thời gian' 
        },
        { 
            field: 'totalOrder', 
            headerName: 'Số lượng', 
            type: "number", 
            styles: { color: "red" } 
        },
        {
            field: 'revenue',
            headerName: 'Tổng tiền đã thu',
            type: "number",
            valueGetter: (params) => convertCurrency(params.row.revenue),
            width: 200,
            cellClassName: (params) => "text1"
        },
        {
            field: 'revenueNoTax',
            headerName: 'Tổng thực thu bán hàng',
            type: "number",
            valueGetter: (params) => convertCurrency(params.row.revenueNoTax),
            width: 230,
            cellClassName: (params) => "text1"
        },
        {
            field: 'owed',
            headerName: 'Còn nợ',
            type: 'number',
            valueGetter: (params) => convertCurrency(params.row.owed), 
            width: 170,
            cellClassName: (params) => "text2"
        },
        {
            field: 'revenueOwe',
            headerName: 'Nợ đã thu',
            type: 'number',
            valueGetter: (params) => convertCurrency(params.row.revenueOwe),
            width: 170,
            cellClassName: (params) => "text1"
        },
        {
            field: 'totalReceiptThuan',
            headerName: 'Tiền phải thu',
            description: 'Tiền phải thu = Doanh số thuần + VAT',
            type: 'number',
            valueGetter: (params) => convertCurrency(params.row.totalReceiptThuan),
            width: 170,
            cellClassName: (params) => "text7"
        },
        {
            field: 'totalNoTax',
            headerName: 'Doanh số thuần',
            description: 'Số tiền cần thu sau khi đã trừ các khoản giảm trừ bao gồm: giảm giá, chiết khấu, thuế (nếu có). (Doanh số thuần = Doanh thu - Giảm giá - VAT)',
            type: 'number',
            valueGetter: (params) => convertCurrency(params.row.totalNoTax),
            width: 170,
            cellClassName: (params) => "text7"
        },
        {
            field: 'deposit',
            headerName: 'Trừ tài khoản',
            type: "number",
            valueGetter: (params) => convertCurrency(params.row.deposit),
            width: 170,
            cellClassName: (params) => "text3"
        },
        {
            field: 'giftCashTotal',
            headerName: 'Trừ điểm tích luỹ',
            type: "number",
            valueGetter: (params) => convertCurrency(params.row.giftCashTotal),
            width: 170,
            cellClassName: (params) => "text3"
        },
        {
            field: 'voucher',
            headerName: 'Trừ Voucher',
            type: "number",
            valueGetter: (params) => convertCurrency(params.row.voucher), 
            width: 170,
            cellClassName: (params) => "text4"
        }
    ];
    const [startDate, setStartDate] = useState(format(new Date(startOfMonth(new Date())),"yyyy-MM-dd"))
    const [endDate, setEndDate] = useState(format(new Date(), 'yyyy-MM-dd'))
    const [store, setStore] = useState(
        (JSON.parse(StorageService.getItem("user_info")) && JSON.parse(StorageService.getItem("user_info")).role == 3) ?
            (JSON.parse(StorageService.getItem("user_info")).stores[0]?.id).toString()
        : StorageService.getItem("currentStore").toString())
    const [sortBy, setSortBy] = useState(0)
    const [typeBHVV, setTypeBHVV] = useState(0)
    const [generalData, setGeneralData] = useState(null)
    const [totalProductOrder, setTotalProductOrder] = useState([])
    const [ordersByDays, setOrdersByDays] = useState([])
    const [receipt, setReceipt] = useState({})
    const [rows, setRows] = useState([])
    const [loading, setLoading] = useState(true);
    const [isExport, setIsExport] = useState(false)
    const [userAdmin, setUserAdmin] = useState(JSON.parse(StorageService.getItem("user_info")))
    const [pageSize, setPageSize] = useState(10)

    let listCategoryIds = [2, 4, 5, 45, 46, 47, 53, 54]

    const handleRangeDate = useCallback((sDate, eDate) => {
        setStartDate(sDate)
        setEndDate(eDate)
    }, [startDate, endDate])

    const handleStore = useCallback((e) => {
        setStore(e.toString())
    }, [store])

    const handleSortBy = useCallback((e) => {
        setSortBy(e)
    }, [sortBy]);

    useLayoutEffect(() => {
        setLoading(true)
        fetchData(store, startDate, endDate, typeBHVV)
    }, [store, endDate, startDate, sortBy, typeBHVV])
    
    const fetchData = async (s, sD, eD, tB) => {
        let payload = {
            stores: s,
            startDate: sD,
            endDate: eD,
            type: tB
        }
        const rs = await axiosService(`api/reports/daily`, "POST", payload)
        const { data } = rs

        if (data.code === 200) {
            let { financialSummary, paidByProduct, transactions, orders } = data.data

            setGeneralData(financialSummary)

            let totalMyPham = 0
            paidByProduct = paidByProduct.filter(item => {
                const isValid = listCategoryIds.includes(item.category_id)
                
                if (Cosmetics.includes(item.category_id)) {
                    totalMyPham += Number(item.sum_paid_order_item || 0)
                }
                return isValid
            })

            if (totalMyPham > 0) {
                paidByProduct.push({
                    sum_paid_order_item: totalMyPham,
                    category_id: 1000,
                    category_name: "Mỹ Phẩm"
                })
            }

            paidByProduct = _.orderBy(paidByProduct, ['sum_paid_order_item'], ['desc']);
            setTotalProductOrder([...paidByProduct])

            let value = "yyyy-MM-dd"

            if (sortBy === 1) {
                value = "ww"
            } else if (sortBy === 2) {
                value = "MM"
            } else if (sortBy === 3) {
                value = "Q"
            }

            let groupTransaction = []
            let groupOrder = []

            if (sortBy === 1) {
                groupTransaction = groupByWeek(transactions, "transaction_at");
                groupOrder = groupByWeek(orders, "order_at");
            } else {
                groupTransaction = _.groupBy(transactions, (x) => format(new Date(x.transaction_at), value))
                groupOrder = _.groupBy(orders, (x) => format(new Date(x.order_at), value))
            }

            const dates = _.uniq([
                ...Object.keys(groupOrder),
                ...Object.keys(groupTransaction)
            ]).sort().reverse()

            const result = dates.map((date, index) => {
                const orders = groupOrder[date] || []
                const transactions = groupTransaction[date] || []

                let totalOrder = orders.length
                let revenue = 0
                let revenueNoTax = 0
                let revenueTax = 0
                let owed = 0
                let revenueOwe = 0
                let totalReceiptThuan = 0
                let totalNoTax = 0
                let totalTax = 0
                let deposit = 0
                let giftCashTotal = 0
                let voucher = 0

                for (let item of orders) {
                    owed += Number(item.order_money_owed || 0)
                    totalReceiptThuan += Number(item.net_price || 0)
                    totalNoTax += Number(item.net_no_tax || 0)
                    totalTax += Number(item.net_tax || 0)
                    voucher += Number(item.order_discount_by_rule || 0)

                }

                for (let item of transactions) {
                    if (["Tiền mặt", "Chuyển khoản", "Quẹt thẻ"].includes(item.pay_type)) {
                        revenue += Number(item.paid_price || 0)
                        revenueNoTax += Number(item.paid_no_tax || 0)
                        revenueTax += Number(item.paid_tax || 0)
                        if (!item.check_tran_status) revenueOwe += Number(item.paid_price || 0)
                    }

                    if (["Sử dụng thẻ tiền"].includes(item.pay_type)) deposit += Number(item.paid_amount)
                    if (["Điểm tích luỹ", "Điểm tích lũy"].includes(item.pay_type)) giftCashTotal += Number(item.paid_amount)
                }

                return {
                    id: index + 1,
                    date,
                    totalOrder,
                    revenue,
                    revenueNoTax,
                    revenueTax,
                    owed,
                    revenueOwe,
                    totalReceiptThuan,
                    totalNoTax,
                    totalTax,
                    deposit,
                    giftCashTotal,
                    voucher
                }
            })

            setRows([...result])

            if (sortBy === 0) {
                const rs = getDates(new Date(sD), new Date(eD)).map(date => {
                    const item = result.find(x => x.date === date)

                    return {
                        date,
                        value: item ? item.revenue : 0
                    }
                })

                setOrdersByDays(rs)
            } else {
                const rs = result.map(x => ({
                    date: x.date,
                    value: x.revenue
                }))

                const data = _.orderBy(rs, ['key'], ['asc'])

                setOrdersByDays(data)
            }
            setLoading(false)
        }
    }

    const groupByWeek = (arr, field) => _.groupBy(arr, (x) => format(startOfWeek(new Date(x[field]), { weekStartsOn: 1 }), "yyyy-MM-dd"));

    function convertCurrency(data) {
        let res = new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(data)
        return res;
    };

    const config = useMemo(() => configChart(ordersByDays, convertCurrency), [ordersByDays])
    
    const handleExportData = () => {
        setIsExport(true)
        setTimeout(() => {
            setIsExport(false)
        }, 2000)
    }

    const handelChange = (e) => {
        setPageSize(e)
    }

    const syncDataGGS = async (e) => {
        setLoading(true)
        const rs = await axiosService(`api/reports/cron-report-ggs`, "GET")
        const { data } = rs
        setLoading(false)
    }
    return (
        <div className={`${styles.background} report-page container-fluid`}>
            <FilterReport startDate={startDate} endDate={endDate}
                handleRangeDate={handleRangeDate} store={store}
                handleStore={handleStore}
                sortBy={sortBy} handleSortBy={handleSortBy}
                typeBHVV={typeBHVV} setTypeBHVV={setTypeBHVV}
                title={"Doanh số theo ngày"} type={"daily"}
                csvData={rows} isExport={isExport}
                handleExportData={handleExportData}
                header={
                    [
                        { label: 'Thời gian', key: "date" },
                        { label: "Số đơn hàng", key: "totalOrder" },
                        { label: "Tiền thực thu", key: "revenue" },
                        { label: "Nợ mới", key: "owed" },
                        { label: "Tiền nợ", key: "revenueOwe" },
                        { label: "Doanh số thuần", key: "totalReceiptThuan" },
                        { label: "Trừ thẻ tiền", key: "deposit" },
                        { label: "Trừ điểm thưởng", key: "giftCashTotal" },
                        { label: "Trừ Voucher", key: "voucher" },
                        { label: "Trừ Combo", key: "combo" },
                    ]
                }
                userAdmin={userAdmin}
            />
            <Spin spinning={loading}>
                <Row className="mt-2">
                    <Col xs={12} md={8}>
                        <Row className="h-100">
                            <Col xs={12} md={3} className="mb-2">
                                <Tag color="blue" className="w-100 p-2 h-100">
                                    <div className={styles.textTag3}>
                                        <Tooltip title='Tổng số tiền đã thu về từ hoạt động bán thẻ dịch vụ, dịch vụ, sản phẩm của công ty từ mọi nguồn gồm cả tiền thu nợ bằng các phương thức thanh toán chuyển khoản, tiền mặt, quẹt thẻ, không bao gồm sử dụng thẻ tiền và điểm tích lũy. ( Tổng tiền đã thu = tiền thu (nguồn Online) + Tiền thu (nguồn KTV) + Nợ đã thu )'>
                                            Tổng tiền đã thu <i className="fas fa-info-circle"></i>
                                        </Tooltip>
                                    </div>
                                    <div className="d-flex justify-content-end mb-2">
                                        <div className={`${styles.textTag} ml-3`}>
                                            {convertCurrency(generalData?.totalRevenue || 0)}
                                        </div>
                                    </div>
                                    <div className={styles.textTag3}>
                                        <Tooltip title='Tổng tiền đã thu trừ VAT'>
                                            Tổng thực thu bán hàng <i className="fas fa-info-circle"></i>
                                        </Tooltip>
                                    </div>
                                    <div className="d-flex justify-content-end mb-2">
                                        <div className={`${styles.textTag} ml-3`}>
                                            {convertCurrency(generalData?.totalRevenueNoTax || 0)}
                                        </div>
                                    </div>
                                    <div className={styles.textTag3}>
                                        <Tooltip title='Số tiền cần thu sau khi đã trừ các khoản giảm trừ bao gồm: giảm giá, chiết khấu, thuế (nếu có). (Doanh số thuần = Doanh số - Giảm giá)'>
                                            Tổng doanh số thuần <i className="fas fa-info-circle"></i>
                                        </Tooltip>
                                    </div>
                                    <div className="d-flex justify-content-end mb-2">
                                        <div className={`${styles.textTag} ml-3`}>
                                            {convertCurrency(generalData?.totalNetNoTax || 0)}
                                        </div>
                                    </div>
                                    <div className={styles.textTag3}>
                                        <Tooltip title='Tổng số lượng hóa đơn hoàn thành ngày hôm đó (bao gồm đơn có tiền, nâng cấp, nạp thẻ tiền, không bao gồm các hóa đơn hủy, chuyển đổi).'>
                                            Số đơn hàng  <i className="fas fa-info-circle"></i>
                                        </Tooltip>
                                    </div>
                                    <div className="d-flex justify-content-end">
                                        <div className={`${styles.textTag} ml-3`}>{generalData?.countOrder || 0}</div>
                                    </div>
                                </Tag>
                            </Col>

                            <Col xs={12} md={3} className="pay_type">
                                <Tag color="violet" className="w-100 h-55 mb-2">
                                    <span className={styles.textTag3}>Thu tiền mặt</span>
                                    <div className="d-flex justify-content-end">
                                        <div className={styles.textTag}>
                                            {convertCurrency(generalData?.paidCash || 0)}
                                        </div>
                                    </div>
                                </Tag>
                                <Tag color="green" className="w-100 h-55 mb-2">
                                    <span className={styles.textTag3}>Thu chuyển khoản</span>
                                    <div className="d-flex justify-content-end">
                                        <div className={styles.textTag}>
                                            {convertCurrency(generalData?.paidBanking || 0)}
                                        </div>
                                    </div>
                                </Tag>

                                <Tag color="red" className="w-100 h-55 mb-2">
                                    <span className={styles.textTag3}>Thu quẹt thẻ</span>
                                    <div className="d-flex justify-content-end">
                                        <div className={styles.textTag}>
                                            {convertCurrency(generalData?.paidCredit || 0)}
                                        </div>
                                    </div>
                                </Tag>
                            </Col>
                            <Col xs={12} md={3} className="mb-2">
                                <Tag color="red" className="w-100 h-100 p-2">
                                    <p className={styles.textTag3}>TÌNH TRẠNG NỢ</p>
                                    <div className="d-flex justify-content-between p-1">
                                        <div>
                                            <p className={styles.textTag4}>
                                                <Tooltip title='Tổng giá trị hàng hóa, dịch vụ, sản phẩm mà khách hàng đã mua nhưng chưa thanh toán.'>
                                                    Còn nợ <i className="fas fa-info-circle"></i>
                                                </Tooltip>
                                            </p>
                                            <p className={styles.textTag4}>
                                                <Tooltip title='Tổng số tiền thu được từ "Tiền nợ".'>
                                                    Nợ đã thu <i className="fas fa-info-circle"></i>
                                                </Tooltip>
                                            </p>
                                        </div>
                                        <div>
                                            <p className={styles.textTag}>{convertCurrency(generalData?.totalOwe || 0)}</p>
                                            <p className={styles.textTag}>{convertCurrency(generalData?.paidOwe || 0)}</p>
                                        </div>
                                    </div>
                                </Tag>
                            </Col>
                        
                            <Col xs={12} md={3} className="pay_type">
                                <Tag color="blue" className="w-100 h-55 mb-2">
                                    <span className={styles.textTag3}>
                                        <Tooltip title='Tổng số tiền khách hàng sử dụng tiền trong tài khoản (trong ví) để thanh toán.'>
                                            Trừ tài khoản <i className="fas fa-info-circle"></i>
                                        </Tooltip>
                                    </span>
                                    <div className="d-flex justify-content-end">
                                        <div>
                                            <span className={styles.textTag}>{convertCurrency(generalData?.paidCentWallet || 0)}</span>
                                        </div>
                                    </div>
                                </Tag>
                                <Tag color="violet" className="w-100 h-55 mb-2">
                                    <span className={styles.textTag3}>
                                        <Tooltip title='Tổng số tiền khách hàng sử dụng điểm tích lũy để thanh toán.'>
                                            Trừ điểm tích luỹ <i className="fas fa-info-circle"></i>
                                        </Tooltip>
                                    </span>
                                    <div className="d-flex justify-content-end">
                                        <div>
                                            <span className={styles.textTag}>{convertCurrency(generalData?.paidLoyalty || 0)}</span>
                                        </div>
                                    </div>
                                </Tag>

                                <Tag color="green" className="w-100 h-55 mb-2">
                                    <span className={styles.textTag3}>
                                        <Tooltip title='Tổng số tiền khách hàng được chiết khấu, giảm giá sau khi áp dụng mã ưu đãi.'>
                                            Trừ voucher <i className="fas fa-info-circle"></i>
                                        </Tooltip>
                                    </span>
                                    <div className="d-flex justify-content-end">
                                        <div>
                                            <span className={styles.textTag}>{convertCurrency(generalData?.voucherDiscount || 0)}</span>
                                        </div>
                                    </div>
                                </Tag>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={12} md={4}>
                        <Row className="mh-180">
                            <Col xs={6}>
                                <Tag color="green" className=" w-100 h-100 p-2">
                                    <p className={styles.textTag3}>
                                    <Tooltip title='Tổng số tiền thu được từ các hoạt động bán thẻ dịch vụ, sản phẩm của công ty từ mọi nguồn gồm cả tiền thu nợ qua các phương thức thanh toán chuyển khoản, tiền mặt, quẹt thẻ, sử dụng thẻ tiền, không bao gồm sử dụng điểm tích lũy.'>
                                    THỰC THU NHÓM DỊCH VỤ <i className="fas fa-info-circle"></i>
                                        </Tooltip>
                                    </p>
                                    <div className="d-flex justify-content-between p-1">
                                        <div>
                                        {totalProductOrder?.map((x,y) => (
                                            listCategoryIds.includes(x.category_id) ?
                                                <p key={y} className={styles.textTag4}>{x.category_name }</p> : null
                                            ))
                                        }
                                        </div>
                                        <div>
                                            {totalProductOrder.map((x,y) => (
                                                listCategoryIds.includes(x.category_id) ?
                                                    <p key={y} className={styles.textTag3}>{convertCurrency(x.sum_paid_order_item || 0)}</p> : null

                                                ))
                                            }
                                        </div>
                                    </div>
                                </Tag>
                            </Col>
                            <Col xs={6}>
                                <Tag color="blue" className=" w-100 h-100 p-2">
                                    <p className={styles.textTag3}>
                                    <Tooltip title='Tổng số tiền thu được từ khách hàng khi nạp tiền vào tài khoản bằng các phương thức thanh toán chuyển khoản, tiền mặt, quẹt thẻ.'>
                                    Tiền Nạp Vào Tài Khoản <i className="fas fa-info-circle"></i>
                                        </Tooltip>
                                    </p>
                                    <div className="d-flex justify-content-end p-1">
                                        <div>
                                            <p className={styles.textTag}>{convertCurrency(generalData?.centWalletTopUp || 0)}</p>
                                        </div>
                                    </div>
                                </Tag>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row className="mt-2" style={{alignItems: 'end'}}>
                    <Col xs={12}>
                        <div style={{ backgroundColor: "white" }} >
                            <div className="border-bottom mb-1 p-2">        
                                <Row>
                                    <Col xs={6}>
                                        <strong>Bảng dữ liệu chi tiết</strong>
                                    </Col>
                                    <Col xs={6} className="text-right">
                                        <Button size="middle" type="primary"
                                            onClick={syncDataGGS}
                                        ><i className="fa-solid fa-file-excel mr-2"></i>Update GGS
                                        </Button>
                                    </Col>
                                </Row>
                            </div>
                            <div style={{ height: 650, width: '100%' }} className="p-2">
                                <DataGrid
                                    rows={rows}
                                    columns={columns}
                                    pageSize={pageSize}
                                    rowsPerPageOptions={[10,15,30,100]}
                                    onPageSizeChange={handelChange}
                                />
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} className="hide-mobile mt-2">
                        <div className="mb-2">
                            <Tooltip title='Chỉ số theo tiền đã thu.'>
                                Biểu đồ <i className="fas fa-info-circle" ></i>
                            </Tooltip>
                        </div>
                        <div style={{ backgroundColor: "white" }} className="p-2">
                            <Line {...config} />
                        </div>
                    </Col>
                </Row>
            </Spin>
        </div >
    )
}

export default ReportDaily